import { FlowsheetConstants } from "@/Flowsheets/FlowsheetConstants";

const careElementUnitMapper: Record<string, string> = {
    [FlowsheetConstants.LabResults.HBA1cCareElementName]: "%",
    [FlowsheetConstants.LabResults.HDLCareElementName]: "mmol/L",
    [FlowsheetConstants.LabResults.LDLCareElementName]: "mmol/L",
    [FlowsheetConstants.LabResults.TGCareElementName]: "mmol/L",
    [FlowsheetConstants.LabResults.AlbuminCreatinineCareElementName]: "mg/mmol",
    [FlowsheetConstants.LabResults.FPGCareElementName]: "mmol/L",
    [FlowsheetConstants.LabResults.GlucoseCareElementName]: "mmol/L",
    [FlowsheetConstants.LabResults.EGFRCareElementName]: "mL/min",
    [FlowsheetConstants.LabResults.AlbuminCareElementName]: "mg/dL",
    [FlowsheetConstants.LabResults.NaCareElementName]: "mmol/L",
    [FlowsheetConstants.LabResults.KCareElementName]: "mmol/L",
    [FlowsheetConstants.LabResults.CreatinineCareElementName]: "umol/L",
    [FlowsheetConstants.LabResults.O2SaturationCareElementName]: "%",
    [FlowsheetConstants.Spirometry.ForcedExpiratoryVolumeInOneSecondCareElementName]: "L",
    [FlowsheetConstants.Spirometry.ForcedVitalCapacityCareElementName]: "L",
    [FlowsheetConstants.Spirometry.ForcedExpiratoryVolumeInOneSecondComparedToPredictedNormalValueCareElementName]: "%",
    [FlowsheetConstants.Spirometry.ForcedVitalCapacityRatioCareElementName]: "%",
    [FlowsheetConstants.Spirometry.ForcedExpiratoryVolumeInOneSecondForcedVitalCapacityRatioCareElementName]: "%",
    [FlowsheetConstants.Spirometry.PersonalPeakExpiratoryFlowCareElementName]: "L/min",
    [FlowsheetConstants.Spirometry.ForcedExpiratoryVolumeInOneSecondRatioCareElementName]: "%",
    [FlowsheetConstants.Spirometry.PredictedCareElemenSuffix]: "%"
};

export { careElementUnitMapper };
